import request from "@/api/request";

//安卓
export function android() {
  return request({
    url: `/app/apn/userSelectList?card=${localStorage.getItem(
      "meCardNum"
    )}&isAndroid=true`,
  });
}

//苹果
export function ios() {
  return request({
    url: `/app/apn/userSelectList?card=${localStorage.getItem(
      "meCardNum"
    )}&isAndroid=false`,
  });
}

//绑定卡号列表
export function cardSave(val) {
  return request({
    url: `/app/cardSave/getAll?card=${localStorage.getItem(
      "meCardNum"
    )}&card2=${val}`,
  });
}

//搜索绑定卡号
export function search(val) {
  return request({
    url: `/app/cardSave/search?card=${localStorage.getItem(
      "meCardNum"
    )}&card2=${val}`,
  });
}
